import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { inject } from 'mobx-react';
import Modal from './modal';
import installIcon from './../assets/img/install-icon.jpg';
import iosInstallStep1 from './../assets/img/ios-install-step-1.png';
import iosInstallStep2EN from './../assets/img/ios-install-step-2-en.png';
import iosInstallStep2FR from './../assets/img/ios-install-step-2-fr.png';
import iosInstallStep3EN from './../assets/img/ios-install-step-3-en.png';
import iosInstallStep3FR from './../assets/img/ios-install-step-3-fr.png';
import iosInstallStep4EN from './../assets/img/ios-install-step-4-en.png';
import iosInstallStep4FR from './../assets/img/ios-install-step-4-fr.png';

const PwaInstallButton = ({ title = 'Download App', className = '', data}) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosPrompt, setShowIosPrompt] = useState(false);
  const [showIosInstallInstructions, setShowIosInstallInstructions] = useState(false);
  const language = data.t.getCurrentLang();
  const iosInstallStep2 = language === 'fr' ? iosInstallStep2FR : iosInstallStep2EN;
  const iosInstallStep3 = language === 'fr' ? iosInstallStep3FR : iosInstallStep3EN;
  const iosInstallStep4 = language === 'fr' ? iosInstallStep4FR : iosInstallStep4EN;

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };

    const isInStandaloneMode = () => 'standalone' in window.navigator && window.navigator.standalone;

    if (isIos() && !isInStandaloneMode()) {
      setShowIosPrompt(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handlePwaInstall = async (e) => {
    e.preventDefault();
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
  };


  if (deferredPrompt) {
    return (
      <a
        href='#'
        onClick={handlePwaInstall}
        title={title}
        className={className}
        style={{ color: 'inherit', textDecoration: 'none', marginRight: 12 }}
        data-testid='download-app-icon'
      >
        <FontAwesomeIcon icon={faDownload} size='lg' />
      </a>
    );
  }

  if (showIosPrompt) {
    return (
      <>
        <div
          style={{
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: 10,
            padding: 12,
            marginBottom: 12,
            textAlign: 'center',
            fontSize: '0.9rem',
            width: 'calc(100% - 20px)',
            margin: '0 10px',
          }}
          onClick={() => setShowIosInstallInstructions(true)}
          className="d-flex justify-content-center align-items-center"
        >
          <p style={{ fontSize: '2rem', margin: '0 5px 0 0' }}>📱</p> <div>{data.t.read('ios_install.banner.text_1')} <strong style={{ fontWeight: 'bold' }}>{data.t.read('ios_install.banner.text_2')}</strong></div>
        </div>
        {showIosInstallInstructions && (
          <Modal okAction={() => setShowIosInstallInstructions(false)} okText={data.t.read('ios_install.confirm_text')} height="calc(100% - 14px)">
            <div className='text-center'>
              <img src={installIcon} alt="Install icon" style={{ width: 63, height: 63, margin: 16 }} />
              <h3>{data.t.read('ios_install.title')}</h3>
              <p style={{ fontSize: '1.1rem' }}>{data.t.read('ios_install.description')}</p>
              <ul style={{ listStyleType: 'none', padding: 0, fontSize: '1.1rem' }}>
                <li className='d-flex flex-column align-items-center p-2'>{data.t.read('ios_install.step_1')}<img src={iosInstallStep1} alt="Install step 1" style={{ width: "calc(100% - 40px)", borderRadius: "10px" }} className="p-2" /></li>
                <li className='d-flex flex-column align-items-center p-2'>{data.t.read('ios_install.step_2')}<img src={iosInstallStep2} alt="Install part 2" style={{ width: "calc(100% - 40px)", borderRadius: "10px" }} className="p-2" /></li>
                <li className='d-flex flex-column align-items-center p-2'>{data.t.read('ios_install.step_3')}<img src={iosInstallStep3} alt="Install part 3" style={{ width: "calc(100% - 40px)", borderRadius: "10px" }} className="p-2" /></li>
                <li className='d-flex flex-column align-items-center p-2'>{data.t.read('ios_install.step_4')}<img src={iosInstallStep4} alt="Install part 4" style={{ width: "calc(100% - 40px)", borderRadius: "10px" }} className="p-2" /></li>
              </ul>
            </div>
          </Modal>
        )}
      </>
    );
  }

  return null;
};

export default inject('data')(PwaInstallButton);
